import { Empty, Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RentalFilters } from 'app/pages/Rental/Views'
import React from 'react'

import { MemberProps } from '../convention'
import RentalCreateButton from './CreateButton'

type Props = {
  hasRentals?: boolean
  setFilter?: (filters: Partial<RentalFilters>) => void
}
const RentalEmpty: React.FC<MemberProps<IRental, Props>> = ({
  props: { hasRentals, setFilter }
}) => {
  const { tCore } = useTranslation({ recordType: RecordType.rental, scope: 'empty' })

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Space direction="vertical">
          <Choose>
            <When condition={hasRentals}>
              <p>{tCore({ id: 'table_scope' })}</p>
              <Button onClick={() => setFilter({ scope: 'all' })} type="primary">
                {tCore({ id: 'table_scope_button' })}
              </Button>
            </When>
            <Otherwise>
              <p>{tCore({ id: 'table' })}</p>
              <RentalCreateButton props={{ type: 'primary', icon: null }} />
            </Otherwise>
          </Choose>
        </Space>
      }
    />
  )
}

export default RentalEmpty
